if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function(callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function() {

    /*
    	HOME ARROW
    	$('.arrow-home').click(function(event) {
    		$('body, html').animate({
    			scrollTop: $(window).height()-$('header').outerHeight()*2},
    			800, 'easeOutExpo');
    	});
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    // SLICK
    const prevArrowHTML =
        `<button class="slick-prev slick-arrow" aria-label="Prev" type="button">
			<svg width="14" height="25" xmlns="http://www.w3.org/2000/svg">
				<use xlink:href="/assets/svg/symbols-2.svg#arrow-left1"></use>
			</svg>
		</button>`;
    const nextArrowtHTML =
        `<button class="slick-next slick-arrow" aria-label="Next" type="button">
			<svg width="14" height="25" xmlns="http://www.w3.org/2000/svg">
				<use xlink:href="/assets/svg/symbols-2.svg#arrow-right1"></use>
			</svg>
		</button>`;

    $('.sym-slides').slick({ 
        accessibility: true,
        prevArrow: prevArrowHTML,
        nextArrow: nextArrowtHTML
    });

    $('.download').click(function(e) {
        e.preventDefault()
        const filename = $(this).attr('download');
        $.post(`${site_url}ajax/functions.php`, { 'operation': 'convertBase64', 'path': $(this).attr('href') }, function(data) {
            const downloadLink = document.createElement("a");
            downloadLink.href = data.url;
            downloadLink.download = filename
            downloadLink.click()
        }, "json")

    })

    // FANCYBOX
    if ($.fancybox) {
        $.fancybox.defaults.tpl.closeBtn =
            `<a title="Close" class="fancybox-item fancybox-close" href="javascript:;">
			<svg width="25" height="25" xmlns="http://www.w3.org/2000/svg">
				<use xlink:href="/assets/svg/symbols-2.svg#close1"></use>
			</svg>
		</a>`;
        $.fancybox.defaults.tpl.prev =
            `<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;">
				<span>
					<svg width="14" height="25" xmlns="http://www.w3.org/2000/svg">
						<use xlink:href="/assets/svg/symbols-2.svg#arrow-left1"></use>
					</svg>
				</span>
			</a>`;
        $.fancybox.defaults.tpl.next =
            `<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;">
				<span>
					<svg width="14" height="25" xmlns="http://www.w3.org/2000/svg">
						<use xlink:href="/assets/svg/symbols-2.svg#arrow-right1"></use>
					</svg>
				</span>
			</a>`;
    }

    $("#form_id-911-yes-signup-formemail-signup").addClass("required");
})();